
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/formacion-de-entrenadores-scrum",
      function () {
        return require("private-next-pages/formacion-de-entrenadores-scrum/index.js");
      }
    ]);
  